import React, { useState } from 'react';
import './FloorMap.css';

const FloorMap = ({ isEnglish }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="floor-map-section">
      <h2 className="floor-map-title">
        {isEnglish ? 'Floor Map' : 'フロアマップ'}
      </h2>

      <img
        src="/images/floormap.jpg"
        alt={isEnglish ? 'Floor Map' : 'フロアマップ'}
        className="floor-map-thumbnail"
        onClick={() => setIsOpen(true)}
      />

      {isOpen && (
        <div className="floor-map-overlay" onClick={() => setIsOpen(false)}>
          <div className="floor-map-modal" onClick={(e) => e.stopPropagation()}>
            <button className="floor-map-close" onClick={() => setIsOpen(false)}>×</button>
            <img
              src="/images/floormap.jpg"
              alt={isEnglish ? 'Expanded Floor Map' : 'フロアマップ拡大'}
              className="floor-map-full"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default FloorMap;
